/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import * as Sentry from "@sentry/react";
import Gohonzon from "../../services/api/gohonzon";
import Button from "../common/Button";
import Modal from "../common/Modal/Modal";
import InputField from "../common/new/InputField/InputField";
import Typography from "../common/new/Typography/Typography";
import styles from "./GohonzonCancelRequestModal.styles";
// import { debounce } from "../../utils/helper";
import { CommonStyles } from "../common/Button/commonButtonStyle";
import { AlertStatus } from "../../contants";

function GohonzonCancelRequestModal({
  application,
  open,
  onClose,
  toast,
  refreshList,
}) {
  const [remark, setRemark] = useState("");

  const submitCancelRequest = async (e) => {
    e.preventDefault();
    try {
      const body = {
        data: {
          message: remark,
        },
      };
      const result = await Gohonzon.gohonzonCancelRequest(
        body,
        application.memberId,
        application.id
      );
      toast.show("Cancel Requested Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onClose();
        refreshList();
      }, 2000);
      console.log(result);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <form onSubmit={submitCancelRequest}>
        <Box>
          <Typography variant="title2" color="#8c8c8c">
            Gohonzon Cancellation Request
          </Typography>
          <Box mt={7}>
            {" "}
            <InputField
              // variant="outlined"
              type="text"
              defaultValue=""
              key="remark"
              name="remark"
              label="Enter your remark here..."
              style={styles.inputStyle}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              InputProps={{ sx: { minHeight: "91px" } }}
            />
          </Box>
        </Box>
        <Box style={styles.replaceGZ}>
          <InfoOutlinedIcon fontSize="small" htmlColor="#FF0100" />{" "}
          <Typography variant="mini" color="#FF0100">
            Gohonzon Cancellation wont be processed until physical gohonzon is
            received by BSG Headquarters.
            <br />
            Kindly return the physical gohonzon to BSG Headquarters.
          </Typography>
        </Box>
        <Box display="flex" gap={6} mt={4}>
          <Button
            type="submit"
            onClick={() => {
              if (!remark) {
                toast.show("Remarks should not be empty!", AlertStatus.ERROR);
              } else {
                submitCancelRequest();
              }
            }}
            style={{ ...CommonStyles.buttonStyle, width: "41%" }}
            label="REQUEST CANCELLATION"
          />
          <Button
            variant="outlined"
            style={{
              ...CommonStyles.buttonStyle,
            }}
            onClick={onClose}
            label="CANCEL"
          />
        </Box>
      </form>
    </Modal>
  );
}

export default GohonzonCancelRequestModal;
